import {Button, Stack} from "@mui/material";
import {useState} from "react";
import APXConfirmationDialog from "./APXConfirmationDialog.jsx";


export interface APXActionButtonsProps {
	  onCancel: () => void;
	  onAdd: () => void;
	  disablePositiveByDefault?: boolean;
	  positiveText?: string;
	  negativeText?: string;
	  shouldShowConfirmationDialog?: boolean;
	  validationProviderAllStateFields?: any[];
	  validationProviderMustNotBeEqualStateFields?: any[][];
}


export default function APXActionButtons({
															 onCancel, onAdd,
															 positiveText = "add", negativeText = "cancel",
															 disablePositiveByDefault = false, shouldShowConfirmationDialog = false,
															 validationProviderAllStateFields = [],
															 validationProviderMustNotBeEqualStateFields = []
													  }: APXActionButtonsProps) {
	  
	  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
	  
	  return (
				 <Stack direction="row" spacing={1} justifyContent="space-between" alignItems="center">
						<Button variant="outlined" fullWidth sx={{m: 1, pt: 1, pb: 1}}
								  onClick={() => onCancel()}
						>
							  {negativeText}
						</Button>
						<Button variant="contained" fullWidth sx={{m: 1, pt: 1, pb: 1}} disabled={disablePositiveByDefault}
								  onClick={() => {
										 if (
													(shouldShowConfirmationDialog)
													&&
													(validationProviderAllStateFields.length === 0 || validationProviderAllStateFields.every((field) => /*TRUTHY->*/ !!field))
													&&
													(validationProviderMustNotBeEqualStateFields.length === 0 || validationProviderMustNotBeEqualStateFields.every((array) => array[0] !== array[1]))
										 ) {
												setShowConfirmationDialog(true);
										 } else {
												onAdd();
										 }
								  }}
						>
							  {positiveText}
						</Button>
						{
								  showConfirmationDialog &&
								  <APXConfirmationDialog
											 onClose={() => {
													setShowConfirmationDialog(false);
													onCancel();
											 }}
											 onConfirmed={() => {
													setShowConfirmationDialog(false);
													onAdd();
											 }}
								  />
						}
				 </Stack>
	  );
}